@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-layout-page-content/lib/index';
@import '~@adv-mt/mt-modal-basic-content/lib/index';
@import '~@adv-mt/mt-modal-transaction-cancel/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-icon/lib/index';
@import '~@s-ui/react-atom-image/lib/index';
@import '~@s-ui/react-molecule-modal/lib/index';
@import '~@s-ui/react-atom-toast/lib/index.scss';
@import '../../components/transactionTrustFooter.scss';

$c-card-ad-attr-item: $c-gray-dark-1 !default;
$h-modal-basic-content-header-image: 180px;
$lh-card-ad-attr-item: 16px !default;
$mah-mt-user-transaction-price-content-mobile: 318px;
$mah-mt-user-transaction-price-content: 418px;
$miw-mt-user-transaction-price-form-button: 200px;
$w-mt-user-transaction-price-side: 328px;
$w-user-transaction-notification-error: 340px;
$w-user-transaction-notification-error-desktop: 300px;

.mt-UserTransactionPriceConfirm {
  &-errorText {
    color: $c-error;
    font-size: $fz-s;
    margin-top: $m-giant;
  }

  &-mainContent {
    display: flex;
    flex-direction: column;
    font-size: $fz-l;
    gap: $g-xl;

    &AdPriceLabel,
    &AgreedPriceLabel {
      font-weight: $fw-regular;
    }

    &AgreedPriceLabel {
      font-weight: $fw-semi-bold;
    }

    &AgreedPriceValue {
      font-weight: $fw-semi-bold;
      font-size: $fz-xl;
    }

    &AdPrice,
    &AgreedPrice {
      display: flex;
      justify-content: space-between;
    }

    &FormButton {
      margin-top: $m-m;
      min-width: 100%;

      @include media-breakpoint-up(l) {
        align-self: flex-end;
        min-width: $miw-mt-user-transaction-price-form-button;
      }
    }

    &FormButtons {
      display: flex;
      flex-direction: column-reverse;

      @include media-breakpoint-up(l) {
        justify-content: flex-end;
        flex-direction: row;
        gap: $g-l;
      }
    }

    &PriceWrapper {
      display: flex;
      flex-direction: column;
      gap: $g-m;
    }
  }

  &-modalReject {
    &ContentHeaderImage {
      height: $h-modal-basic-content-header-image;
      margin-bottom: $m-xl;
    }
  }

  &-helpText {
    align-items: center;
    background-color: $c-neutral;
    border-radius: $bdrs-l;
    display: flex;
    font-size: $fz-l;
    gap: $g-m;
    padding: $p-l;
  }

  &-notification {
    background-color: $c-error;
    color: $c-white;
    display: flex;
    align-items: center;
    gap: $g-m;
    padding: $p-s;
    width: $w-user-transaction-notification-error;

    @include media-breakpoint-up(m) {
      width: $w-user-transaction-notification-error-desktop;
    }

    &Text {
      margin: 0;
    }
  }
}
